import React, { useContext, useState } from "react";
import { StatsContainer, StyledStats } from "../dashboard.style";
import TimeMenu from "./TimeMenu";
import StatsCard from "./StatsCard";
import FixelDataContext from "../../../context/FixelDataContext";

const Stats = () => {
  const [timeSelected, setTimeSelected] = useState("LAST_7_DAYS");
  const { fullFixelData } = useContext(FixelDataContext);

  const selectTime = (e) => {
    setTimeSelected(e.target.getAttribute("value"));
  };

  return (
    <StatsContainer>
      <TimeMenu selectTime={selectTime} timeSelected={timeSelected} />

      <StyledStats>
        <StatsCard
          tooltipContent="A session is the period time a user is actively engaged with your website"
          cardTitle="Sessions Analyzed"
          sessionNum={fullFixelData[timeSelected] && fullFixelData[timeSelected].fixelStats.total}
          changeRate={fullFixelData[timeSelected] && fullFixelData[timeSelected].fixelStats.totalChange}
        />
        <StatsCard
          tooltipContent="The number of sessions that showed a basic level of engagement. Highly engaged sessions are included too."
          cardTitle="Engaged Sessions"
          sessionNum={fullFixelData[timeSelected] && fullFixelData[timeSelected].fixelStats.Engaged}
          changeRate={fullFixelData[timeSelected] && fullFixelData[timeSelected].fixelStats.EngagedChange}
        />
        <StatsCard
          tooltipContent="The number of sessions that showed a high level of engagement"
          cardTitle="Highly Engaged Sessions"
          sessionNum={fullFixelData[timeSelected] && fullFixelData[timeSelected].fixelStats.highEngaged}
          changeRate={fullFixelData[timeSelected] && fullFixelData[timeSelected].fixelStats.highEngagedChange}
        />
      </StyledStats>
    </StatsContainer>
  );
};
export default Stats;
